(function (angular) {
    'use strict';

    angular.module('app').controller('app.footerController', ['$location', footerController]);

    function footerController($location) {
        var vm = this;
        vm.siteContent = siteContent;

        vm.isWelcomePage = $location.path().toString() === '/welcome';
        onInit();

        function onInit() {
            getYear();
            console.log('in footer: ', vm.siteContent.site.footer.texts);
            if(vm.siteContent.site.footer.texts.length === 3){
                vm.siteContent.site.footer.texts.pop();
            }
        }

        function getYear() {
            var today = new Date();
            vm.currentYear = today.getFullYear();
        }
    }
})(angular);
